import { XIcon } from '@heroicons/react/solid'
import { Text } from '@ui/elements/text'

import toast, { Toaster, ToastBar } from 'react-hot-toast'

export default function Notifications() {
  return (
    <div>
      <Toaster
        position='top-right'
        toastOptions={{
          style: {
            color: 'black',
            backgroundColor: 'white',
            border: '1px solid #9ca3af'
          },
          loading: { theme: { primary: 'indigo', secondary: 'black' } }
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <div
                className='flex'
                onMouseDown={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  e.nativeEvent.stopImmediatePropagation()
                }}
              >
                {icon}
                <div className='font-normal text-sm'>{message}</div>
                {t.type !== 'loading' && (
                  <div className='ml-4 my-1 shrink-0 flex'>
                    <button
                      className='bg-transparent rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                      onClick={() => {
                        toast.dismiss(t.id)
                      }}
                    >
                      <Text as='span' className='sr-only'>
                        Close
                      </Text>
                      <XIcon className='h-5 w-5' aria-hidden='true' />
                    </button>
                  </div>
                )}
              </div>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  )
}
